import { useContext } from "react";
import { BurgerButtonBig, ButtonRound, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './Start.css';
import { LocaleContext, ScrollContext } from "../common/App";
import { Footer } from "./WebsiteCommon";
import { useNavigateSmart } from "../common/hooks";

export function Start(props) {
    const locale = useContext(LocaleContext);
    const navigate = useNavigateSmart();
    const scroll = useContext(ScrollContext);

    return (
        <div>
            <img className="img_width" src="/customer/header_homepage.jpg"></img>
            <div className="text_box">
                <div className="text_small">{locale.msgs.STARTPAGE_NUREMBERG}</div>
                <div id="in_good_hands" className="text_big_big">{locale.msgs.IN_GOOD_HANDS}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.IN_GOOD_HANDS_DESCR}}></div>

                <LearnMore onClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/about_us");
                            }}/>

                <div id="how_brokerage_works" className="text_big_big">{locale.msgs.HOW_BROKERAGE_WORKS}</div>
            </div>

            <img className="img_width margin_top_low_low" src="/customer/02_body_dashboard_family.jpg"></img>

            <div className="text_box">
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.HOW_BROKERAGE_WORKS_DESCR}}></div>

                <LearnMore onClick={() => {
                                scroll.scrollToPlain(0, 0);
                                navigate("/how_it_works");
                            }}/>

                <div id="find_m_n">
                    <SignupBox header={locale.msgs.FIND_MANNY_OR_NANNY} descr={locale.msgs.FIND_MANNY_OR_NANNY_DESCR_START}
                            onClick={() => navigate("/register_fam") } />
                </div>
                
                <div id="find_job">
                    <SignupBox header={locale.msgs.FIND_JOB} descr={locale.msgs.FIND_JOB_DESCR_START}
                            onClick={() => navigate("/register_mn") } />
                </div>
            </div>

            <img className="margin_top_high img_width" src="/customer/body_for-mannynanny.jpg"></img>

            {/*
            <div className="text_box_gray">
                <div id="academy" className="text_big_big">{locale.msgs.OUR_ACADEMY}</div>
                <div className="text">{locale.msgs.OUR_ACADEMY_DESCR}</div>
                <LearnMore href="/login"/>
            </div>
            */}

            <div id="all_for_all_box" className="text_box">
                <div className="text_big_big">{locale.msgs.ALL_FOR_ALL}</div>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.ALL_FOR_ALL_DESCR}}></div>
            </div>

            <Footer />
        </div>
    );
}
